
"use client";

import { Home, Target, Wand2, List, Plus } from "lucide-react";
import { Button } from "./ui/button";
import { cn } from "@/lib/utils";

type TabsLayoutProps = {
  activeTab: string;
  onTabChange: (tab: string) => void;
  onAddClick?: () => void;
};

const tabs = [
  { id: 'home', label: 'Home', icon: <Home className="h-5 w-5" /> },
  { id: 'log', label: 'Log', icon: <List className="h-5 w-5" /> },
  // Middle button will be inserted manually
  { id: 'goals', label: 'Goals', icon: <Target className="h-5 w-5" /> },
  { id: 'coach', label: 'AI Coach', icon: <Wand2 className="h-5 w-5" /> },
];

export function TabsLayout({ activeTab, onTabChange, onAddClick }: TabsLayoutProps) {
  return (
    <div className="fixed bottom-0 left-0 right-0 border-t bg-background/95 backdrop-blur-sm z-10 safe-area-bottom">
      <div className="flex items-center justify-around h-16 px-2">
        <div className="flex items-center justify-around w-full md:w-auto md:gap-2">
          {tabs.slice(0, 2).map(tab => (
            <Button
              key={tab.id}
              variant="ghost"
              className={cn(
                "flex-col h-auto p-2 gap-1 text-xs rounded-lg md:flex-row md:text-sm md:h-10 md:px-4 md:py-2 min-w-[64px]",
                activeTab === tab.id
                  ? 'bg-secondary text-secondary-foreground'
                  : 'text-muted-foreground'
              )}
              onClick={() => {
                if (activeTab === tab.id) {
                  if (tab.id === 'coach') {
                    // For chat conversation, scroll to the latest messages at the bottom
                    const docHeight = Math.max(
                      document.body?.scrollHeight || 0,
                      document.documentElement?.scrollHeight || 0
                    );
                    window.scrollTo({ top: docHeight, behavior: 'smooth' });
                  } else {
                    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                  }
                } else {
                  onTabChange(tab.id);
                }
              }}
            >
              {tab.icon}
              <span>{tab.label}</span>
            </Button>
          ))}

          <div className="relative -top-5">
            <Button
              className="h-14 w-14 rounded-full shadow-lg bg-primary hover:bg-primary/90 text-primary-foreground border-4 border-background"
              onClick={onAddClick}
              aria-label="Add Sleep Event"
            >
              <Plus className="h-8 w-8" />
            </Button>
          </div>

          {tabs.slice(2).map(tab => (
            <Button
              key={tab.id}
              variant="ghost"
              className={cn(
                "flex-col h-auto p-2 gap-1 text-xs rounded-lg md:flex-row md:text-sm md:h-10 md:px-4 md:py-2 min-w-[64px]",
                activeTab === tab.id
                  ? 'bg-secondary text-secondary-foreground'
                  : 'text-muted-foreground'
              )}
              onClick={() => {
                if (activeTab === tab.id) {
                  if (tab.id === 'coach') {
                    // For chat conversation, scroll to the latest messages at the bottom
                    const docHeight = Math.max(
                      document.body?.scrollHeight || 0,
                      document.documentElement?.scrollHeight || 0
                    );
                    window.scrollTo({ top: docHeight, behavior: 'smooth' });
                  } else {
                    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                  }
                } else {
                  onTabChange(tab.id);
                }
              }}
            >
              {tab.icon}
              <span>{tab.label}</span>
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
}
